import lazyLoading from "./lazyLoading";

export default {
  name: "help",
  path: "/help",
  component: lazyLoading("help/Informacije"),
  meta: {
    default: false,
    expanded: false,
    title: "Informacije",
    class: "primary",
    show: false,
    iconClass: "fa fa-support",
    requiredAuth: true
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/help.js